import { IconButton, IconButtonProps } from '@mui/material'
import { icons } from 'src/design-system'

import Iconify from './Iconify'

// ----------------------------------------------------------------------
// The one way out of anything that opens over the console: a dialog, a sheet,
// a drawer, a callout on the map.
//
// Each of those used to draw its own. Two dialogs had an X in a title row of
// its own, painted black whatever the scheme; the filter sheet drew a 20px
// glyph and the map callout an 18px one in a smaller box; and the other fifty
// dialogs, the booking calendar's among them, drew none, so the only way out
// was a Cancel at the foot or a click on the scrim.
//
// So the mark, its box and its name are stated here once. A surface decides
// where the button stands; a dialog does not even decide that, because
// `components/Dialog` puts it in the paper's corner for every one of them.
// ----------------------------------------------------------------------

export type CloseButtonProps = Omit<IconButtonProps, 'children' | 'size'>

export default function CloseButton({
  'aria-label': name = 'Close',
  ...props
}: CloseButtonProps) {
  return (
    <IconButton aria-label={name} {...props}>
      <Iconify size="control" icon={icons.close} />
    </IconButton>
  )
}
